// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__C4UAr","left":"index_left__H_qS4","swiper":"index_swiper___UIyo"};